"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var core_2 = require("@21st-night/core");
var LoadingIndicator_1 = __importDefault(require("../../LoadingIndicator"));
var RichTextEditor_1 = __importStar(require("../../RichTextEditor"));
var DeckNoteCreateCardButton_1 = __importDefault(require("../DeckNoteCreateCardButton"));
var CreateCardDialog_1 = __importDefault(require("../../CardEditor/CreateCardDialog"));
function mergeDeckNote(noteData, deckNote, noteId) {
    var content = deckNote.content, rest = __rest(deckNote, ["content"]);
    var data = __assign(__assign(__assign({}, noteData), rest), { id: noteId });
    if (deckNote.contentEdited) {
        data.content = content;
    }
    return data;
}
exports.useStyles = styles_1.makeStyles(function (theme) {
    var _a;
    return styles_1.createStyles({
        root: (_a = {
                padding: theme.spacing(3),
                borderRadius: 8,
                marginBottom: theme.spacing(2)
            },
            _a[theme.breakpoints.down('xs')] = {
                borderRadius: 0,
            },
            _a),
        content: {
            maxWidth: 700,
            width: '100%',
            marginRight: 'auto',
            marginLeft: 'auto',
        },
        loading: {
            padding: theme.spacing(4, 0),
            textAlign: 'center',
        },
    });
});
var DeckNote = function (_a) {
    var classNameProp = _a.className, noteId = _a.noteId, onClickCardLink = _a.onClickCardLink, other = __rest(_a, ["className", "noteId", "onClickCardLink"]);
    var classes = exports.useStyles();
    var db = core_2.useFirebase().db;
    var _b = __read(react_1.useState(false), 2), cardDialogOpen = _b[0], setCardDialogOpen = _b[1];
    var _c = __read(react_1.useState(), 2), card = _c[0], setCard = _c[1];
    var deck = core_2.useDeck();
    var _d = __read(react_1.useState(true), 2), loading = _d[0], setLoading = _d[1];
    var _e = __read(react_1.useState(null), 2), note = _e[0], setNote = _e[1];
    var deckNote = deck.notes.find(function (note) { return note.id === noteId; });
    react_1.useEffect(function () {
        deck.updateNoteLastViewed(noteId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [noteId]);
    react_1.useEffect(function () {
        setLoading(true);
        setNote(null);
        var unsubscribe = db
            .collection('notes')
            .doc(noteId)
            .onSnapshot(function (doc) {
            var docData = doc.data();
            if (docData) {
                var data = __assign({}, docData);
                if (deckNote) {
                    data = mergeDeckNote(data, deckNote, noteId);
                    setNote(data);
                    setLoading(false);
                }
            }
        });
        return function () { return unsubscribe(); };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [noteId]);
    function handleClickCreateCard(event, fragment, editor) {
        if (note && editor.selection) {
            var selection = editor.selection;
            setCard(__assign(__assign({}, core_2.createCardDocument()), { question: fragment, note: noteId, linkedNote: {
                    content: JSON.parse(note.content),
                    selection: selection,
                }, category: note.category, subcategories: note.subcategories }));
            setCardDialogOpen(true);
        }
    }
    return (react_1.default.createElement(core_1.Paper, __assign({ className: clsx_1.default(classes.root, loading && classes.loading, classNameProp) }, other),
        loading && react_1.default.createElement(LoadingIndicator_1.default, { size: "large" }),
        !loading && note && (react_1.default.createElement("div", { className: classes.content },
            react_1.default.createElement(core_1.Typography, { gutterBottom: true, variant: "h3" }, note.title),
            react_1.default.createElement(RichTextEditor_1.default, { selectionOnly: true, disableToolbar: true, updateFromInitialValue: true, disableHoveringToolbar: true, highlightCardLink: "all", onClickCardLink: onClickCardLink, initialValue: JSON.parse(note.content) },
                react_1.default.createElement(RichTextEditor_1.EditorHoveringToolbar, { controls: [] },
                    react_1.default.createElement(DeckNoteCreateCardButton_1.default, { onClick: handleClickCreateCard }))))),
        react_1.default.createElement(CreateCardDialog_1.default, { open: cardDialogOpen, card: card, onCancel: function () { return setCardDialogOpen(false); }, onSuccess: function () { return setCardDialogOpen(false); } })));
};
exports.default = DeckNote;
//# sourceMappingURL=DeckNote.js.map